let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hU0gB")).then(() => parcelRequire('laEC1'));